import { colorCategories } from "@/mocks/colors";

const COLUMNS = [
  {
    title: "站内导航",
    links: [
      { label: "色系分类", href: "#series" },
      { label: "色卡图鉴", href: "#atlas" },
      { label: "跨系对照", href: "#compare" },
      { label: "应用场景", href: "#scenes" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "六色系脉络",
    links: colorCategories.map((c) => ({ label: `${c.seq} ${c.name}`, href: "#atlas" })),
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-accent-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* 品牌 */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex w-10 h-10 items-center justify-center rounded-md bg-background-50 overflow-hidden">
                <span className="w-4 h-4 rounded-[2px] bg-accent-900" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-background-50 font-serif text-lg tracking-wide">黑料色</span>
                <span className="text-accent-300 text-[10px] tracking-display uppercase mt-1">Color Atlas</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-[14px] leading-7 text-accent-200/90">
              专注黑色系色号、色卡与图鉴的分类归档。六条黑料色脉络按类目排好，
              为设计师与配色从业者提供可复现、易定位的黑色系参考。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-qq-line", "ri-wechat-line", "ri-mail-line"].map((ic) => (
                <a
                  key={ic}
                  href="mailto:hello@heiliaose.example.com"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-accent-700 text-accent-200 hover:bg-background-50 hover:text-accent-900 transition-colors"
                  aria-label="联系方式"
                >
                  <i className={`${ic} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-background-50 font-medium text-sm">{col.title}</h3>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-[13px] text-accent-200/85 hover:text-background-50 transition-colors whitespace-nowrap">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-accent-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-accent-300/80">
            © {new Date().getFullYear()} 黑料色色卡图鉴 · 黑色系色号与色卡分类整理
          </p>
          <p className="text-[13px] text-accent-300/70">
            参考邮箱：hello@heiliaose.example.com
          </p>
        </div>
      </div>
    </footer>
  );
}